 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');
 				link.crossOrigin = "anonymous";
 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}
 	function hotDisposeChunk(chunkId) {
 		delete installedChunks[chunkId];
 	}
 	var parentHotUpdateCallback = window["webpackHotUpdate"];
 	window["webpackHotUpdate"] = // eslint-disable-next-line no-unused-vars
 	function webpackHotUpdateCallback(chunkId, moreModules) {
 		hotAddUpdateChunk(chunkId, moreModules);
 		if (parentHotUpdateCallback) parentHotUpdateCallback(chunkId, moreModules);
 	} ;

 	// eslint-disable-next-line no-unused-vars
 	function hotDownloadUpdateChunk(chunkId) {
 		var script = document.createElement("script");
 		script.charset = "utf-8";
 		script.src = __webpack_require__.p + "" + chunkId + "." + hotCurrentHash + ".hot-update.js";
 		if ("anonymous") script.crossOrigin = "anonymous";
 		document.head.appendChild(script);
 	}

 	// eslint-disable-next-line no-unused-vars
 	function hotDownloadManifest(requestTimeout) {
 		requestTimeout = requestTimeout || 10000;
 		return new Promise(function(resolve, reject) {
 			if (typeof XMLHttpRequest === "undefined") {
 				return reject(new Error("No browser support"));
 			}
 			try {
 				var request = new XMLHttpRequest();
 				var requestPath = __webpack_require__.p + "" + hotCurrentHash + ".hot-update.json";
 				request.open("GET", requestPath, true);
 				request.timeout = requestTimeout;
 				request.send(null);
 			} catch (err) {
 				return reject(err);
 			}
 			request.onreadystatechange = function() {
 				if (request.readyState !== 4) return;
 				if (request.status === 0) {
 					// timeout
 					reject(
 						new Error("Manifest request to " + requestPath + " timed out.")
 					);
 				} else if (request.status === 404) {
 					// no update available
 					resolve();
 				} else if (request.status !== 200 && request.status !== 304) {
 					// other failure
 					reject(new Error("Manifest request to " + requestPath + " failed."));
 				} else {
 					// success
 					try {
 						var update = JSON.parse(request.responseText);
 					} catch (e) {
 						reject(e);
 						return;
 					}
 					resolve(update);
 				}
 			};
 		});
 	}

 	var hotApplyOnUpdate = true;
 	// eslint-disable-next-line no-unused-vars
 	var hotCurrentHash = "6a4b9c8f3aeb63194dfc";
 	var hotRequestTimeout = 10000;
 	var hotCurrentModuleData = {};
 	var hotCurrentChildModule;
 	// eslint-disable-next-line no-unused-vars
 	var hotCurrentParents = [];
 	// eslint-disable-next-line no-unused-vars
 	var hotCurrentParentsTemp = [];

 	// eslint-disable-next-line no-unused-vars
 	function hotCreateRequire(moduleId) {
 		var me = installedModules[moduleId];
 		if (!me) return __webpack_require__;
 		var fn = function(request) {
 			if (me.hot.active) {
 				if (installedModules[request]) {
 					if (installedModules[request].parents.indexOf(moduleId) === -1) {
 						installedModules[request].parents.push(moduleId);
 					}
 				} else {
 					hotCurrentParents = [moduleId];
 					hotCurrentChildModule = request;
 				}
 				if (me.children.indexOf(request) === -1) {
 					me.children.push(request);
 				}
 			} else {
 				console.warn(
 					"[HMR] unexpected require(" +
 						request +
 						") from disposed module " +
 						moduleId
 				);
 				hotCurrentParents = [];
 			}
 			return __webpack_require__(request);
 		};
 		var ObjectFactory = function ObjectFactory(name) {
 			return {
 				configurable: true,
 				enumerable: true,
 				get: function() {
 					return __webpack_require__[name];
 				},
 				set: function(value) {
 					__webpack_require__[name] = value;
 				}
 			};
 		};
 		for (var name in __webpack_require__) {
 			if (
 				Object.prototype.hasOwnProperty.call(__webpack_require__, name) &&
 				name !== "e" &&
 				name !== "t"
 			) {
 				Object.defineProperty(fn, name, ObjectFactory(name));
 			}
 		}
 		fn.e = function(chunkId) {
 			if (hotStatus === "ready") hotSetStatus("prepare");
 			hotChunksLoading++;
 			return __webpack_require__.e(chunkId).then(finishChunkLoading, function(err) {
 				finishChunkLoading();
 				throw err;
 			});

 			function finishChunkLoading() {
 				hotChunksLoading--;
 				if (hotStatus === "prepare") {
 					if (!hotWaitingFilesMap[chunkId]) {
 						hotEnsureUpdateChunk(chunkId);
 					}
 					if (hotChunksLoading === 0 && hotWaitingFiles === 0) {
 						hotUpdateDownloaded();
 					}
 				}
 			}
 		};
 		fn.t = function(value, mode) {
 			if (mode & 1) value = fn(value);
 			return __webpack_require__.t(value, mode & ~1);
 		};
 		return fn;
 	}

 	// eslint-disable-next-line no-unused-vars
 	function hotCreateModule(moduleId) {
 		var hot = {
 			// private stuff
 			_acceptedDependencies: {},
 			_declinedDependencies: {},
 			_selfAccepted: false,
 			_selfDeclined: false,
 			_disposeHandlers: [],
 			_main: hotCurrentChildModule !== moduleId,

 			// Module API
 			active: true,
 			accept: function(dep, callback) {
 				if (dep === undefined) hot._selfAccepted = true;
 				else if (typeof dep === "function") hot._selfAccepted = dep;
 				else if (typeof dep === "object")
 					for (var i = 0; i < dep.length; i++)
 						hot._acceptedDependencies[dep[i]] = callback || function() {};
 				else hot._acceptedDependencies[dep] = callback || function() {};
 			},
 			decline: function(dep) {
 				if (dep === undefined) hot._selfDeclined = true;
 				else if (typeof dep === "object")
 					for (var i = 0; i < dep.length; i++)
 						hot._declinedDependencies[dep[i]] = true;
 				else hot._declinedDependencies[dep] = true;
 			},
 			dispose: function(callback) {
 				hot._disposeHandlers.push(callback);
 			},
 			addDisposeHandler: function(callback) {
 				hot._disposeHandlers.push(callback);
 			},
 			removeDisposeHandler: function(callback) {
 				var idx = hot._disposeHandlers.indexOf(callback);
 				if (idx >= 0) hot._disposeHandlers.splice(idx, 1);
 			},

 			// Management API
 			check: hotCheck,
 			apply: hotApply,
 			status: function(l) {
 				if (!l) return hotStatus;
 				hotStatusHandlers.push(l);
 			},
 			addStatusHandler: function(l) {
 				hotStatusHandlers.push(l);
 			},
 			removeStatusHandler: function(l) {
 				var idx = hotStatusHandlers.indexOf(l);
 				if (idx >= 0) hotStatusHandlers.splice(idx, 1);
 			},

 			//inherit from previous dispose call
 			data: hotCurrentModuleData[moduleId]
 		};
 		hotCurrentChildModule = undefined;
 		return hot;
 	}

 	var hotStatusHandlers = [];
 	var hotStatus = "idle";

 	function hotSetStatus(newStatus) {
 		hotStatus = newStatus;
 		for (var i = 0; i < hotStatusHandlers.length; i++)
 			hotStatusHandlers[i].call(null, newStatus);
 	}

 	// while downloading
 	var hotWaitingFiles = 0;
 	var hotChunksLoading = 0;
 	var hotWaitingFilesMap = {};
 	var hotRequestedFilesMap = {};
 	var hotAvailableFilesMap = {};
 	var hotDeferred;

 	// The update info
 	var hotUpdate, hotUpdateNewHash;

 	function toModuleId(id) {
 		var isNumber = +id + "" === id;
 		return isNumber ? +id : id;
 	}

 	function hotCheck(apply) {
 		if (hotStatus !== "idle") {
 			throw new Error("check() is only allowed in idle status");
 		}
 		hotApplyOnUpdate = apply;
 		hotSetStatus("check");
 		return hotDownloadManifest(hotRequestTimeout).then(function(update) {
 			if (!update) {
 				hotSetStatus("idle");
 				return null;
 			}
 			hotRequestedFilesMap = {};
 			hotWaitingFilesMap = {};
 			hotAvailableFilesMap = update.c;
 			hotUpdateNewHash = update.h;

 			hotSetStatus("prepare");
 			var promise = new Promise(function(resolve, reject) {
 				hotDeferred = {
 					resolve: resolve,
 					reject: reject
 				};
 			});
 			hotUpdate = {};
 			for(var chunkId in installedChunks)
 			// eslint-disable-next-line no-lone-blocks
 			{
 				/*globals chunkId */
 				hotEnsureUpdateChunk(chunkId);
 			}
 			if (
 				hotStatus === "prepare" &&
 				hotChunksLoading === 0 &&
 				hotWaitingFiles === 0
 			) {
 				hotUpdateDownloaded();
 			}
 			return promise;
 		});
 	}

 	// eslint-disable-next-line no-unused-vars
 	function hotAddUpdateChunk(chunkId, moreModules) {
 		if (!hotAvailableFilesMap[chunkId] || !hotRequestedFilesMap[chunkId])
 			return;
 		hotRequestedFilesMap[chunkId] = false;
 		for (var moduleId in moreModules) {
 			if (Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				hotUpdate[moduleId] = moreModules[moduleId];
 			}
 		}
 		if (--hotWaitingFiles === 0 && hotChunksLoading === 0) {
 			hotUpdateDownloaded();
 		}
 	}

 	function hotEnsureUpdateChunk(chunkId) {
 		if (!hotAvailableFilesMap[chunkId]) {
 			hotWaitingFilesMap[chunkId] = true;
 		} else {
 			hotRequestedFilesMap[chunkId] = true;
 			hotWaitingFiles++;
 			hotDownloadUpdateChunk(chunkId);
 		}
 	}

 	function hotUpdateDownloaded() {
 		hotSetStatus("ready");
 		var deferred = hotDeferred;
 		hotDeferred = null;
 		if (!deferred) return;
 		if (hotApplyOnUpdate) {
 			// Wrap deferred object in Promise to mark it as a well-handled Promise to
 			// avoid triggering uncaught exception warning in Chrome.
 			// See https://bugs.chromium.org/p/chromium/issues/detail?id=465666
 			Promise.resolve()
 				.then(function() {
 					return hotApply(hotApplyOnUpdate);
 				})
 				.then(
 					function(result) {
 						deferred.resolve(result);
 					},
 					function(err) {
 						deferred.reject(err);
 					}
 				);
 		} else {
 			var outdatedModules = [];
 			for (var id in hotUpdate) {
 				if (Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
 					outdatedModules.push(toModuleId(id));
 				}
 			}
 			deferred.resolve(outdatedModules);
 		}
 	}

 	function hotApply(options) {
 		if (hotStatus !== "ready")
 			throw new Error("apply() is only allowed in ready status");
 		options = options || {};

 		var cb;
 		var i;
 		var j;
 		var module;
 		var moduleId;

 		function getAffectedStuff(updateModuleId) {
 			var outdatedModules = [updateModuleId];
 			var outdatedDependencies = {};

 			var queue = outdatedModules.slice().map(function(id) {
 				return {
 					chain: [id],
 					id: id
 				};
 			});
 			while (queue.length > 0) {
 				var queueItem = queue.pop();
 				var moduleId = queueItem.id;
 				var chain = queueItem.chain;
 				module = installedModules[moduleId];
 				if (!module || module.hot._selfAccepted) continue;
 				if (module.hot._selfDeclined) {
 					return {
 						type: "self-declined",
 						chain: chain,
 						moduleId: moduleId
 					};
 				}
 				if (module.hot._main) {
 					return {
 						type: "unaccepted",
 						chain: chain,
 						moduleId: moduleId
 					};
 				}
 				for (var i = 0; i < module.parents.length; i++) {
 					var parentId = module.parents[i];
 					var parent = installedModules[parentId];
 					if (!parent) continue;
 					if (parent.hot._declinedDependencies[moduleId]) {
 						return {
 							type: "declined",
 							chain: chain.concat([parentId]),
 							moduleId: moduleId,
 							parentId: parentId
 						};
 					}
 					if (outdatedModules.indexOf(parentId) !== -1) continue;
 					if (parent.hot._acceptedDependencies[moduleId]) {
 						if (!outdatedDependencies[parentId])
 							outdatedDependencies[parentId] = [];
 						addAllToSet(outdatedDependencies[parentId], [moduleId]);
 						continue;
 					}
 					delete outdatedDependencies[parentId];
 					outdatedModules.push(parentId);
 					queue.push({
 						chain: chain.concat([parentId]),
 						id: parentId
 					});
 				}
 			}

 			return {
 				type: "accepted",
 				moduleId: updateModuleId,
 				outdatedModules: outdatedModules,
 				outdatedDependencies: outdatedDependencies
 			};
 		}

 		function addAllToSet(a, b) {
 			for (var i = 0; i < b.length; i++) {
 				var item = b[i];
 				if (a.indexOf(item) === -1) a.push(item);
 			}
 		}

 		// at begin all updates modules are outdated
 		// the "outdated" status can propagate to parents if they don't accept the children
 		var outdatedDependencies = {};
 		var outdatedModules = [];
 		var appliedUpdate = {};

 		var warnUnexpectedRequire = function warnUnexpectedRequire() {
 			console.warn(
 				"[HMR] unexpected require(" + result.moduleId + ") to disposed module"
 			);
 		};

 		for (var id in hotUpdate) {
 			if (Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
 				moduleId = toModuleId(id);
 				/** @type {TODO} */
 				var result;
 				if (hotUpdate[id]) {
 					result = getAffectedStuff(moduleId);
 				} else {
 					result = {
 						type: "disposed",
 						moduleId: id
 					};
 				}
 				/** @type {Error|false} */
 				var abortError = false;
 				var doApply = false;
 				var doDispose = false;
 				var chainInfo = "";
 				if (result.chain) {
 					chainInfo = "\nUpdate propagation: " + result.chain.join(" -> ");
 				}
 				switch (result.type) {
 					case "self-declined":
 						if (options.onDeclined) options.onDeclined(result);
 						if (!options.ignoreDeclined)
 							abortError = new Error(
 								"Aborted because of self decline: " +
 									result.moduleId +
 									chainInfo
 							);
 						break;
 					case "declined":
 						if (options.onDeclined) options.onDeclined(result);
 						if (!options.ignoreDeclined)
 							abortError = new Error(
 								"Aborted because of declined dependency: " +
 									result.moduleId +
 									" in " +
 									result.parentId +
 									chainInfo
 							);
 						break;
 					case "unaccepted":
 						if (options.onUnaccepted) options.onUnaccepted(result);
 						if (!options.ignoreUnaccepted)
 							abortError = new Error(
 								"Aborted because " + moduleId + " is not accepted" + chainInfo
 							);
 						break;
 					case "accepted":
 						if (options.onAccepted) options.onAccepted(result);
 						doApply = true;
 						break;
 					case "disposed":
 						if (options.onDisposed) options.onDisposed(result);
 						doDispose = true;
 						break;
 					default:
 						throw new Error("Unexception type " + result.type);
 				}
 				if (abortError) {
 					hotSetStatus("abort");
 					return Promise.reject(abortError);
 				}
 				if (doApply) {
 					appliedUpdate[moduleId] = hotUpdate[moduleId];
 					addAllToSet(outdatedModules, result.outdatedModules);
 					for (moduleId in result.outdatedDependencies) {
 						if (
 							Object.prototype.hasOwnProperty.call(
 								result.outdatedDependencies,
 								moduleId
 							)
 						) {
 							if (!outdatedDependencies[moduleId])
 								outdatedDependencies[moduleId] = [];
 							addAllToSet(
 								outdatedDependencies[moduleId],
 								result.outdatedDependencies[moduleId]
 							);
 						}
 					}
 				}
 				if (doDispose) {
 					addAllToSet(outdatedModules, [result.moduleId]);
 					appliedUpdate[moduleId] = warnUnexpectedRequire;
 				}
 			}
 		}

 		// Store self accepted outdated modules to require them later by the module system
 		var outdatedSelfAcceptedModules = [];
 		for (i = 0; i < outdatedModules.length; i++) {
 			moduleId = outdatedModules[i];
 			if (
 				installedModules[moduleId] &&
 				installedModules[moduleId].hot._selfAccepted
 			)
 				outdatedSelfAcceptedModules.push({
 					module: moduleId,
 					errorHandler: installedModules[moduleId].hot._selfAccepted
 				});
 		}

 		// Now in "dispose" phase
 		hotSetStatus("dispose");
 		Object.keys(hotAvailableFilesMap).forEach(function(chunkId) {
 			if (hotAvailableFilesMap[chunkId] === false) {
 				hotDisposeChunk(chunkId);
 			}
 		});

 		var idx;
 		var queue = outdatedModules.slice();
 		while (queue.length > 0) {
 			moduleId = queue.pop();
 			module = installedModules[moduleId];
 			if (!module) continue;

 			var data = {};

 			// Call dispose handlers
 			var disposeHandlers = module.hot._disposeHandlers;
 			for (j = 0; j < disposeHandlers.length; j++) {
 				cb = disposeHandlers[j];
 				cb(data);
 			}
 			hotCurrentModuleData[moduleId] = data;

 			// disable module (this disables requires from this module)
 			module.hot.active = false;

 			// remove module from cache
 			delete installedModules[moduleId];

 			// when disposing there is no need to call dispose handler
 			delete outdatedDependencies[moduleId];

 			// remove "parents" references from all children
 			for (j = 0; j < module.children.length; j++) {
 				var child = installedModules[module.children[j]];
 				if (!child) continue;
 				idx = child.parents.indexOf(moduleId);
 				if (idx >= 0) {
 					child.parents.splice(idx, 1);
 				}
 			}
 		}

 		// remove outdated dependency from module children
 		var dependency;
 		var moduleOutdatedDependencies;
 		for (moduleId in outdatedDependencies) {
 			if (
 				Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)
 			) {
 				module = installedModules[moduleId];
 				if (module) {
 					moduleOutdatedDependencies = outdatedDependencies[moduleId];
 					for (j = 0; j < moduleOutdatedDependencies.length; j++) {
 						dependency = moduleOutdatedDependencies[j];
 						idx = module.children.indexOf(dependency);
 						if (idx >= 0) module.children.splice(idx, 1);
 					}
 				}
 			}
 		}

 		// Not in "apply" phase
 		hotSetStatus("apply");

 		hotCurrentHash = hotUpdateNewHash;

 		// insert new code
 		for (moduleId in appliedUpdate) {
 			if (Object.prototype.hasOwnProperty.call(appliedUpdate, moduleId)) {
 				modules[moduleId] = appliedUpdate[moduleId];
 			}
 		}

 		// call accept handlers
 		var error = null;
 		for (moduleId in outdatedDependencies) {
 			if (
 				Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)
 			) {
 				module = installedModules[moduleId];
 				if (module) {
 					moduleOutdatedDependencies = outdatedDependencies[moduleId];
 					var callbacks = [];
 					for (i = 0; i < moduleOutdatedDependencies.length; i++) {
 						dependency = moduleOutdatedDependencies[i];
 						cb = module.hot._acceptedDependencies[dependency];
 						if (cb) {
 							if (callbacks.indexOf(cb) !== -1) continue;
 							callbacks.push(cb);
 						}
 					}
 					for (i = 0; i < callbacks.length; i++) {
 						cb = callbacks[i];
 						try {
 							cb(moduleOutdatedDependencies);
 						} catch (err) {
 							if (options.onErrored) {
 								options.onErrored({
 									type: "accept-errored",
 									moduleId: moduleId,
 									dependencyId: moduleOutdatedDependencies[i],
 									error: err
 								});
 							}
 							if (!options.ignoreErrored) {
 								if (!error) error = err;
 							}
 						}
 					}
 				}
 			}
 		}

 		// Load self accepted modules
 		for (i = 0; i < outdatedSelfAcceptedModules.length; i++) {
 			var item = outdatedSelfAcceptedModules[i];
 			moduleId = item.module;
 			hotCurrentParents = [moduleId];
 			try {
 				__webpack_require__(moduleId);
 			} catch (err) {
 				if (typeof item.errorHandler === "function") {
 					try {
 						item.errorHandler(err);
 					} catch (err2) {
 						if (options.onErrored) {
 							options.onErrored({
 								type: "self-accept-error-handler-errored",
 								moduleId: moduleId,
 								error: err2,
 								originalError: err
 							});
 						}
 						if (!options.ignoreErrored) {
 							if (!error) error = err2;
 						}
 						if (!error) error = err;
 					}
 				} else {
 					if (options.onErrored) {
 						options.onErrored({
 							type: "self-accept-errored",
 							moduleId: moduleId,
 							error: err
 						});
 					}
 					if (!options.ignoreErrored) {
 						if (!error) error = err;
 					}
 				}
 			}
 		}

 		// handle errors in accept handlers and self accepted module load
 		if (error) {
 			hotSetStatus("fail");
 			return Promise.reject(error);
 		}

 		hotSetStatus("idle");
 		return new Promise(function(resolve) {
 			resolve(outdatedModules);
 		});
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		1: 0
 	}

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		1: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"2":"src-docs-documentation-component-reference-accordion-accordion","3":"src-docs-documentation-component-reference-bar-bar","4":"src-docs-documentation-component-reference-board-board","5":"src-docs-documentation-component-reference-button-button","6":"src-docs-documentation-component-reference-calendar-calendar","7":"src-docs-documentation-component-reference-carousel-carousel","8":"src-docs-documentation-component-reference-conditional-conditional","9":"src-docs-documentation-component-reference-container-container","10":"src-docs-documentation-component-reference-email-email","11":"src-docs-documentation-component-reference-field-field","12":"src-docs-documentation-component-reference-file-upload-file-upload","13":"src-docs-documentation-component-reference-form-form","14":"src-docs-documentation-component-reference-gallery-gallery","15":"src-docs-documentation-component-reference-highlight-highlight","16":"src-docs-documentation-component-reference-html-html","17":"src-docs-documentation-component-reference-i-frame-i-frame","18":"src-docs-documentation-component-reference-icon-icon","19":"src-docs-documentation-component-reference-image-image","20":"src-docs-documentation-component-reference-label-label","21":"src-docs-documentation-component-reference-line-line","22":"src-docs-documentation-component-reference-link-wrapper-link-wrapper","23":"src-docs-documentation-component-reference-list-view-list-view","24":"src-docs-documentation-component-reference-navigation-navigation","25":"src-docs-documentation-component-reference-page-content-page-content","26":"src-docs-documentation-component-reference-pie-pie","27":"src-docs-documentation-component-reference-repeater-repeater","28":"src-docs-documentation-component-reference-scroll-spy-scroll-spy","29":"src-docs-documentation-component-reference-search-search","30":"src-docs-documentation-component-reference-status-bar-status-bar","31":"src-docs-documentation-component-reference-tabs-tabs","32":"src-docs-documentation-component-reference-timeline-timeline","33":"src-docs-documentation-component-reference-wizard-wizard","34":"src-docs-documentation-config-apps","35":"src-docs-documentation-config-assignments","36":"src-docs-documentation-config-components","37":"src-docs-documentation-config-layouts","38":"src-docs-documentation-config-pages","39":"src-docs-documentation-config-propsmapper","40":"src-docs-documentation-config-quick-start","41":"src-docs-documentation-config-themes","42":"src-docs-documentation-data-data","43":"src-docs-documentation-data-datastore","44":"src-docs-documentation-data-intro","45":"src-docs-documentation-data-transformation","46":"src-docs-documentation-datasources-integration-docusign","47":"src-docs-documentation-datasources-integration-ds-getting-started","48":"src-docs-documentation-datasources-integration-dynamo-db","49":"src-docs-documentation-datasources-integration-epicor","50":"src-docs-documentation-datasources-integration-function","51":"src-docs-documentation-datasources-integration-google-sheet","52":"src-docs-documentation-datasources-integration-json-api","53":"src-docs-documentation-datasources-integration-notifications","54":"src-docs-documentation-datasources-integration-s4hana","55":"src-docs-documentation-datasources-integration-salesforce","56":"src-docs-documentation-datasources-integration-salesforce-chatter","57":"src-docs-documentation-datasources-integration-salesforce-method","58":"src-docs-documentation-datasources-integration-twilio","59":"src-docs-documentation-datasources-integration-websocket","60":"src-docs-documentation-datasources-utility-clientroutes","61":"src-docs-documentation-datasources-utility-credentials","62":"src-docs-documentation-datasources-utility-emailer","63":"src-docs-documentation-datasources-utility-files","64":"src-docs-documentation-datasources-utility-javascript","65":"src-docs-documentation-datasources-utility-json","66":"src-docs-documentation-datasources-utility-state","67":"src-docs-documentation-datasources-utility-user","68":"src-docs-documentation-datasources-utility-users","69":"src-docs-documentation-getting-started-101","70":"src-docs-documentation-getting-started-best-practices","71":"src-docs-documentation-getting-started-faq","72":"src-docs-documentation-getting-started-glossary-of-terms","73":"src-docs-documentation-getting-started-release-notes","74":"src-docs-documentation-getting-started-release-notes-2020-01-24","75":"src-docs-documentation-getting-started-release-notes-2020-02-19","76":"src-docs-documentation-getting-started-release-notes-2020-02-21","77":"src-docs-documentation-getting-started-release-notes-2020-03-09","78":"src-docs-documentation-getting-started-release-notes-2020-03-23","79":"src-docs-documentation-getting-started-release-notes-2020-04-09","80":"src-docs-documentation-getting-started-release-notes-2020-04-27","81":"src-docs-documentation-getting-started-release-notes-2020-05-11","82":"src-docs-documentation-getting-started-release-notes-2020-05-27","83":"src-docs-documentation-getting-started-release-notes-2020-07-16","84":"src-docs-documentation-getting-started-release-notes-2020-09-16","85":"src-docs-documentation-getting-started-release-notes-2020-10-02","86":"src-docs-documentation-getting-started-release-notes-2020-10-07","87":"src-docs-documentation-getting-started-release-notes-2020-10-27","88":"src-docs-documentation-getting-started-release-notes-2020-12-02","89":"src-docs-documentation-getting-started-release-notes-2021-02-04","90":"src-docs-documentation-getting-started-release-notes-2021-06-02","91":"src-docs-documentation-getting-started-release-notes-2021-07-06","92":"src-docs-documentation-getting-started-release-notes-2021-08-12","93":"src-docs-documentation-getting-started-release-notes-2021-10-06","94":"src-docs-documentation-getting-started-release-notes-2021-11-15","95":"src-docs-documentation-getting-started-release-notes-2022-02-02","96":"src-docs-documentation-guidelines-index","97":"src-docs-documentation-lessons-lesson1","98":"src-docs-documentation-lessons-lesson1a","99":"src-docs-documentation-lessons-lesson1b","100":"src-docs-documentation-lessons-lesson1c","101":"src-docs-documentation-lessons-lesson1d","102":"src-docs-documentation-lessons-lesson1e","103":"src-docs-documentation-management-index","104":"src-docs-documentation-polystack-solutions-client","105":"src-docs-documentation-polystack-solutions-crm-for-startups","106":"src-docs-documentation-polystack-solutions-dev","107":"src-docs-documentation-polystack-solutions-digital-banking","108":"src-docs-documentation-polystack-solutions-employee-portal","109":"src-docs-documentation-polystack-solutions-ethic","110":"src-docs-documentation-polystack-solutions-family-office","111":"src-docs-documentation-polystack-solutions-investment-research","112":"src-docs-documentation-polystack-solutions-project-mngmnt","113":"src-docs-documentation-polystack-solutions-residential-lending","114":"src-docs-documentation-releases-index","115":"src-docs-documentation-security-index","116":"src-docs-documentation-user-managment-admins","117":"src-docs-documentation-user-managment-intro","118":"src-docs-documentation-user-managment-users","119":"src-docs-documentation-utility-apps-board","120":"src-docs-documentation-utility-apps-calendar","121":"src-docs-documentation-utility-apps-data-mashup","122":"src-docs-documentation-utility-apps-easy-minutes","123":"src-docs-documentation-utility-apps-expenses","124":"src-docs-documentation-utility-apps-google-sheets-dashboard","125":"src-docs-documentation-utility-apps-index","126":"src-docs-documentation-utility-apps-intro","127":"src-docs-documentation-utility-apps-lwc-component","128":"src-docs-documentation-utility-apps-portals","129":"src-docs-documentation-utility-apps-project-mgmt","130":"src-docs-documentation-utility-apps-public-sign-up","131":"src-docs-documentation-utility-apps-user-feedback","132":"src-docs-home-index"}[chunkId]||chunkId) + "." + {"2":"e6daee04","3":"03901015","4":"d7d8dfbf","5":"59ab88ba","6":"9435e554","7":"fe6ac8f4","8":"b8a25879","9":"aeace7e4","10":"f3eb84d5","11":"027c5ecf","12":"a989d010","13":"154a0c3b","14":"0a1c8072","15":"757841ae","16":"63691512","17":"e65a70df","18":"d5c8879b","19":"80909c6a","20":"7be4d3d2","21":"32409931","22":"42987809","23":"1c228844","24":"c39b5f90","25":"bb9a3ab8","26":"cff22128","27":"f683df06","28":"95af4eff","29":"0f411498","30":"06996241","31":"0f2dd887","32":"93d0a541","33":"2385e37c","34":"67aed474","35":"e6b0f8ea","36":"38410f65","37":"88e6a45f","38":"b954f602","39":"06f69cdd","40":"c6b3a1e8","41":"9cad4ded","42":"79b20007","43":"378761a3","44":"e704f3ff","45":"9989c36a","46":"a7cc809e","47":"a75c7001","48":"4c3046e5","49":"42552660","50":"4f2953e1","51":"20df03f9","52":"c8cfee1f","53":"2f054bd3","54":"36712137","55":"8a9075f6","56":"c41ffbc6","57":"e6f62d57","58":"3e1be64e","59":"fe5de83a","60":"1bb1db57","61":"dea1737e","62":"9185e1ef","63":"79ce89e9","64":"073a8bd8","65":"23e5980a","66":"aa34b0b4","67":"c7e559d1","68":"62d0cce8","69":"0243b66c","70":"71e441e7","71":"5177b9bb","72":"d944c281","73":"4d7e1b2c","74":"a5ccc6da","75":"488978cd","76":"824bb11c","77":"6506e7f7","78":"91c5d04b","79":"e8c37a8b","80":"ddec91f6","81":"e5428879","82":"5b484a5f","83":"65034c62","84":"27854676","85":"da67d794","86":"64cd69ca","87":"8e6bcc29","88":"6e7cfda6","89":"a5db6511","90":"b94393f5","91":"be4275dd","92":"c85f613c","93":"880a61d7","94":"ddef986a","95":"60d91438","96":"1ea37214","97":"739b06cf","98":"99fb97a0","99":"3d457572","100":"607bb256","101":"7a8e9f63","102":"35e2053e","103":"8f65c4e3","104":"c70f0e7e","105":"6c9b3587","106":"e7247b92","107":"dd145e5b","108":"60e4a81c","109":"7d58a5bf","110":"dea32a02","111":"9354fc9d","112":"666694d9","113":"9929b88c","114":"89ee449a","115":"9bdf329a","116":"a2a738c3","117":"a58230b4","118":"64d0b6bf","119":"66960484","120":"ee5e36fa","121":"5c4aef86","122":"11d667c1","123":"583ae49c","124":"b1a3c79d","125":"87e38d00","126":"bdc89213","127":"7efc145a","128":"b88a6548","129":"a0d902a0","130":"22b5a6f2","131":"2cec0fb3","132":"22b58a20"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {},
 			hot: hotCreateModule(moduleId),
 			parents: (hotCurrentParentsTemp = hotCurrentParents, hotCurrentParents = [], hotCurrentParentsTemp),
 			children: []
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, hotCreateRequire(moduleId));

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"33":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"2":"src-docs-documentation-component-reference-accordion-accordion","3":"src-docs-documentation-component-reference-bar-bar","4":"src-docs-documentation-component-reference-board-board","5":"src-docs-documentation-component-reference-button-button","6":"src-docs-documentation-component-reference-calendar-calendar","7":"src-docs-documentation-component-reference-carousel-carousel","8":"src-docs-documentation-component-reference-conditional-conditional","9":"src-docs-documentation-component-reference-container-container","10":"src-docs-documentation-component-reference-email-email","11":"src-docs-documentation-component-reference-field-field","12":"src-docs-documentation-component-reference-file-upload-file-upload","13":"src-docs-documentation-component-reference-form-form","14":"src-docs-documentation-component-reference-gallery-gallery","15":"src-docs-documentation-component-reference-highlight-highlight","16":"src-docs-documentation-component-reference-html-html","17":"src-docs-documentation-component-reference-i-frame-i-frame","18":"src-docs-documentation-component-reference-icon-icon","19":"src-docs-documentation-component-reference-image-image","20":"src-docs-documentation-component-reference-label-label","21":"src-docs-documentation-component-reference-line-line","22":"src-docs-documentation-component-reference-link-wrapper-link-wrapper","23":"src-docs-documentation-component-reference-list-view-list-view","24":"src-docs-documentation-component-reference-navigation-navigation","25":"src-docs-documentation-component-reference-page-content-page-content","26":"src-docs-documentation-component-reference-pie-pie","27":"src-docs-documentation-component-reference-repeater-repeater","28":"src-docs-documentation-component-reference-scroll-spy-scroll-spy","29":"src-docs-documentation-component-reference-search-search","30":"src-docs-documentation-component-reference-status-bar-status-bar","31":"src-docs-documentation-component-reference-tabs-tabs","32":"src-docs-documentation-component-reference-timeline-timeline","33":"src-docs-documentation-component-reference-wizard-wizard","34":"src-docs-documentation-config-apps","35":"src-docs-documentation-config-assignments","36":"src-docs-documentation-config-components","37":"src-docs-documentation-config-layouts","38":"src-docs-documentation-config-pages","39":"src-docs-documentation-config-propsmapper","40":"src-docs-documentation-config-quick-start","41":"src-docs-documentation-config-themes","42":"src-docs-documentation-data-data","43":"src-docs-documentation-data-datastore","44":"src-docs-documentation-data-intro","45":"src-docs-documentation-data-transformation","46":"src-docs-documentation-datasources-integration-docusign","47":"src-docs-documentation-datasources-integration-ds-getting-started","48":"src-docs-documentation-datasources-integration-dynamo-db","49":"src-docs-documentation-datasources-integration-epicor","50":"src-docs-documentation-datasources-integration-function","51":"src-docs-documentation-datasources-integration-google-sheet","52":"src-docs-documentation-datasources-integration-json-api","53":"src-docs-documentation-datasources-integration-notifications","54":"src-docs-documentation-datasources-integration-s4hana","55":"src-docs-documentation-datasources-integration-salesforce","56":"src-docs-documentation-datasources-integration-salesforce-chatter","57":"src-docs-documentation-datasources-integration-salesforce-method","58":"src-docs-documentation-datasources-integration-twilio","59":"src-docs-documentation-datasources-integration-websocket","60":"src-docs-documentation-datasources-utility-clientroutes","61":"src-docs-documentation-datasources-utility-credentials","62":"src-docs-documentation-datasources-utility-emailer","63":"src-docs-documentation-datasources-utility-files","64":"src-docs-documentation-datasources-utility-javascript","65":"src-docs-documentation-datasources-utility-json","66":"src-docs-documentation-datasources-utility-state","67":"src-docs-documentation-datasources-utility-user","68":"src-docs-documentation-datasources-utility-users","69":"src-docs-documentation-getting-started-101","70":"src-docs-documentation-getting-started-best-practices","71":"src-docs-documentation-getting-started-faq","72":"src-docs-documentation-getting-started-glossary-of-terms","73":"src-docs-documentation-getting-started-release-notes","74":"src-docs-documentation-getting-started-release-notes-2020-01-24","75":"src-docs-documentation-getting-started-release-notes-2020-02-19","76":"src-docs-documentation-getting-started-release-notes-2020-02-21","77":"src-docs-documentation-getting-started-release-notes-2020-03-09","78":"src-docs-documentation-getting-started-release-notes-2020-03-23","79":"src-docs-documentation-getting-started-release-notes-2020-04-09","80":"src-docs-documentation-getting-started-release-notes-2020-04-27","81":"src-docs-documentation-getting-started-release-notes-2020-05-11","82":"src-docs-documentation-getting-started-release-notes-2020-05-27","83":"src-docs-documentation-getting-started-release-notes-2020-07-16","84":"src-docs-documentation-getting-started-release-notes-2020-09-16","85":"src-docs-documentation-getting-started-release-notes-2020-10-02","86":"src-docs-documentation-getting-started-release-notes-2020-10-07","87":"src-docs-documentation-getting-started-release-notes-2020-10-27","88":"src-docs-documentation-getting-started-release-notes-2020-12-02","89":"src-docs-documentation-getting-started-release-notes-2021-02-04","90":"src-docs-documentation-getting-started-release-notes-2021-06-02","91":"src-docs-documentation-getting-started-release-notes-2021-07-06","92":"src-docs-documentation-getting-started-release-notes-2021-08-12","93":"src-docs-documentation-getting-started-release-notes-2021-10-06","94":"src-docs-documentation-getting-started-release-notes-2021-11-15","95":"src-docs-documentation-getting-started-release-notes-2022-02-02","96":"src-docs-documentation-guidelines-index","97":"src-docs-documentation-lessons-lesson1","98":"src-docs-documentation-lessons-lesson1a","99":"src-docs-documentation-lessons-lesson1b","100":"src-docs-documentation-lessons-lesson1c","101":"src-docs-documentation-lessons-lesson1d","102":"src-docs-documentation-lessons-lesson1e","103":"src-docs-documentation-management-index","104":"src-docs-documentation-polystack-solutions-client","105":"src-docs-documentation-polystack-solutions-crm-for-startups","106":"src-docs-documentation-polystack-solutions-dev","107":"src-docs-documentation-polystack-solutions-digital-banking","108":"src-docs-documentation-polystack-solutions-employee-portal","109":"src-docs-documentation-polystack-solutions-ethic","110":"src-docs-documentation-polystack-solutions-family-office","111":"src-docs-documentation-polystack-solutions-investment-research","112":"src-docs-documentation-polystack-solutions-project-mngmnt","113":"src-docs-documentation-polystack-solutions-residential-lending","114":"src-docs-documentation-releases-index","115":"src-docs-documentation-security-index","116":"src-docs-documentation-user-managment-admins","117":"src-docs-documentation-user-managment-intro","118":"src-docs-documentation-user-managment-users","119":"src-docs-documentation-utility-apps-board","120":"src-docs-documentation-utility-apps-calendar","121":"src-docs-documentation-utility-apps-data-mashup","122":"src-docs-documentation-utility-apps-easy-minutes","123":"src-docs-documentation-utility-apps-expenses","124":"src-docs-documentation-utility-apps-google-sheets-dashboard","125":"src-docs-documentation-utility-apps-index","126":"src-docs-documentation-utility-apps-intro","127":"src-docs-documentation-utility-apps-lwc-component","128":"src-docs-documentation-utility-apps-portals","129":"src-docs-documentation-utility-apps-project-mgmt","130":"src-docs-documentation-utility-apps-public-sign-up","131":"src-docs-documentation-utility-apps-user-feedback","132":"src-docs-home-index"}[chunkId]||chunkId) + "." + hotCurrentHash + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"33":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"2":"src-docs-documentation-component-reference-accordion-accordion","3":"src-docs-documentation-component-reference-bar-bar","4":"src-docs-documentation-component-reference-board-board","5":"src-docs-documentation-component-reference-button-button","6":"src-docs-documentation-component-reference-calendar-calendar","7":"src-docs-documentation-component-reference-carousel-carousel","8":"src-docs-documentation-component-reference-conditional-conditional","9":"src-docs-documentation-component-reference-container-container","10":"src-docs-documentation-component-reference-email-email","11":"src-docs-documentation-component-reference-field-field","12":"src-docs-documentation-component-reference-file-upload-file-upload","13":"src-docs-documentation-component-reference-form-form","14":"src-docs-documentation-component-reference-gallery-gallery","15":"src-docs-documentation-component-reference-highlight-highlight","16":"src-docs-documentation-component-reference-html-html","17":"src-docs-documentation-component-reference-i-frame-i-frame","18":"src-docs-documentation-component-reference-icon-icon","19":"src-docs-documentation-component-reference-image-image","20":"src-docs-documentation-component-reference-label-label","21":"src-docs-documentation-component-reference-line-line","22":"src-docs-documentation-component-reference-link-wrapper-link-wrapper","23":"src-docs-documentation-component-reference-list-view-list-view","24":"src-docs-documentation-component-reference-navigation-navigation","25":"src-docs-documentation-component-reference-page-content-page-content","26":"src-docs-documentation-component-reference-pie-pie","27":"src-docs-documentation-component-reference-repeater-repeater","28":"src-docs-documentation-component-reference-scroll-spy-scroll-spy","29":"src-docs-documentation-component-reference-search-search","30":"src-docs-documentation-component-reference-status-bar-status-bar","31":"src-docs-documentation-component-reference-tabs-tabs","32":"src-docs-documentation-component-reference-timeline-timeline","33":"src-docs-documentation-component-reference-wizard-wizard","34":"src-docs-documentation-config-apps","35":"src-docs-documentation-config-assignments","36":"src-docs-documentation-config-components","37":"src-docs-documentation-config-layouts","38":"src-docs-documentation-config-pages","39":"src-docs-documentation-config-propsmapper","40":"src-docs-documentation-config-quick-start","41":"src-docs-documentation-config-themes","42":"src-docs-documentation-data-data","43":"src-docs-documentation-data-datastore","44":"src-docs-documentation-data-intro","45":"src-docs-documentation-data-transformation","46":"src-docs-documentation-datasources-integration-docusign","47":"src-docs-documentation-datasources-integration-ds-getting-started","48":"src-docs-documentation-datasources-integration-dynamo-db","49":"src-docs-documentation-datasources-integration-epicor","50":"src-docs-documentation-datasources-integration-function","51":"src-docs-documentation-datasources-integration-google-sheet","52":"src-docs-documentation-datasources-integration-json-api","53":"src-docs-documentation-datasources-integration-notifications","54":"src-docs-documentation-datasources-integration-s4hana","55":"src-docs-documentation-datasources-integration-salesforce","56":"src-docs-documentation-datasources-integration-salesforce-chatter","57":"src-docs-documentation-datasources-integration-salesforce-method","58":"src-docs-documentation-datasources-integration-twilio","59":"src-docs-documentation-datasources-integration-websocket","60":"src-docs-documentation-datasources-utility-clientroutes","61":"src-docs-documentation-datasources-utility-credentials","62":"src-docs-documentation-datasources-utility-emailer","63":"src-docs-documentation-datasources-utility-files","64":"src-docs-documentation-datasources-utility-javascript","65":"src-docs-documentation-datasources-utility-json","66":"src-docs-documentation-datasources-utility-state","67":"src-docs-documentation-datasources-utility-user","68":"src-docs-documentation-datasources-utility-users","69":"src-docs-documentation-getting-started-101","70":"src-docs-documentation-getting-started-best-practices","71":"src-docs-documentation-getting-started-faq","72":"src-docs-documentation-getting-started-glossary-of-terms","73":"src-docs-documentation-getting-started-release-notes","74":"src-docs-documentation-getting-started-release-notes-2020-01-24","75":"src-docs-documentation-getting-started-release-notes-2020-02-19","76":"src-docs-documentation-getting-started-release-notes-2020-02-21","77":"src-docs-documentation-getting-started-release-notes-2020-03-09","78":"src-docs-documentation-getting-started-release-notes-2020-03-23","79":"src-docs-documentation-getting-started-release-notes-2020-04-09","80":"src-docs-documentation-getting-started-release-notes-2020-04-27","81":"src-docs-documentation-getting-started-release-notes-2020-05-11","82":"src-docs-documentation-getting-started-release-notes-2020-05-27","83":"src-docs-documentation-getting-started-release-notes-2020-07-16","84":"src-docs-documentation-getting-started-release-notes-2020-09-16","85":"src-docs-documentation-getting-started-release-notes-2020-10-02","86":"src-docs-documentation-getting-started-release-notes-2020-10-07","87":"src-docs-documentation-getting-started-release-notes-2020-10-27","88":"src-docs-documentation-getting-started-release-notes-2020-12-02","89":"src-docs-documentation-getting-started-release-notes-2021-02-04","90":"src-docs-documentation-getting-started-release-notes-2021-06-02","91":"src-docs-documentation-getting-started-release-notes-2021-07-06","92":"src-docs-documentation-getting-started-release-notes-2021-08-12","93":"src-docs-documentation-getting-started-release-notes-2021-10-06","94":"src-docs-documentation-getting-started-release-notes-2021-11-15","95":"src-docs-documentation-getting-started-release-notes-2022-02-02","96":"src-docs-documentation-guidelines-index","97":"src-docs-documentation-lessons-lesson1","98":"src-docs-documentation-lessons-lesson1a","99":"src-docs-documentation-lessons-lesson1b","100":"src-docs-documentation-lessons-lesson1c","101":"src-docs-documentation-lessons-lesson1d","102":"src-docs-documentation-lessons-lesson1e","103":"src-docs-documentation-management-index","104":"src-docs-documentation-polystack-solutions-client","105":"src-docs-documentation-polystack-solutions-crm-for-startups","106":"src-docs-documentation-polystack-solutions-dev","107":"src-docs-documentation-polystack-solutions-digital-banking","108":"src-docs-documentation-polystack-solutions-employee-portal","109":"src-docs-documentation-polystack-solutions-ethic","110":"src-docs-documentation-polystack-solutions-family-office","111":"src-docs-documentation-polystack-solutions-investment-research","112":"src-docs-documentation-polystack-solutions-project-mngmnt","113":"src-docs-documentation-polystack-solutions-residential-lending","114":"src-docs-documentation-releases-index","115":"src-docs-documentation-security-index","116":"src-docs-documentation-user-managment-admins","117":"src-docs-documentation-user-managment-intro","118":"src-docs-documentation-user-managment-users","119":"src-docs-documentation-utility-apps-board","120":"src-docs-documentation-utility-apps-calendar","121":"src-docs-documentation-utility-apps-data-mashup","122":"src-docs-documentation-utility-apps-easy-minutes","123":"src-docs-documentation-utility-apps-expenses","124":"src-docs-documentation-utility-apps-google-sheets-dashboard","125":"src-docs-documentation-utility-apps-index","126":"src-docs-documentation-utility-apps-intro","127":"src-docs-documentation-utility-apps-lwc-component","128":"src-docs-documentation-utility-apps-portals","129":"src-docs-documentation-utility-apps-project-mgmt","130":"src-docs-documentation-utility-apps-public-sign-up","131":"src-docs-documentation-utility-apps-user-feedback","132":"src-docs-home-index"}[chunkId]||chunkId) + "." + hotCurrentHash + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// __webpack_hash__
 	__webpack_require__.h = function() { return hotCurrentHash; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	webpackJsonpCallback([[], {}, 0, [0,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,37,38,39,40,41,42,43,44,45,46,48,49,50,51,52,53,54,55,57,58,59,60,61,62,63,64,65,66,67,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,97,98,99,100,101,102,116,118,36,47,56,68,69,70,71,72,96,103,104,105,106,107,108,109,110,111,112,113,114,115,117,119,120,121,122,123,124,125,126,127,128,129,130,131,132]]);
 	// add entry module to deferred list
 	deferredModules.push([0,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
